var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8Z",
    fill: "url(#paint0_linear_5444_10398)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7597 9.742C4.81762 9.68408 4.89727 9.65032 4.98174 9.65032H12.6426C12.7826 9.65032 12.8526 9.81928 12.7537 9.91824L11.2403 11.4316C11.1824 11.4895 11.1027 11.5233 11.0182 11.5233H3.35738C3.21738 11.5233 3.14738 11.3543 3.24634 11.2554L4.7597 9.742Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7597 4.09172C4.82003 4.03379 4.89969 4 4.98174 4H12.6426C12.7826 4 12.8526 4.16895 12.7537 4.26791L11.2403 5.78126C11.1824 5.83919 11.1027 5.87298 11.0182 5.87298H3.35738C3.21738 5.87298 3.14738 5.70402 3.24634 5.60506L4.7597 4.09172Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2403 6.89877C11.1824 6.84085 11.1027 6.80706 11.0182 6.80706H3.35738C3.21738 6.80706 3.14738 6.97601 3.24634 7.07497L4.7597 8.58832C4.81762 8.64624 4.89727 8.68 4.98174 8.68H12.6426C12.7826 8.68 12.8526 8.51104 12.7537 8.41216L11.2403 6.89877Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5444_10398",
    x1: 16,
    y1: -9.53674e-7,
    x2: -9.53674e-7,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.8162d01261123021af3d6d050a4eb295.svg";
export { ForwardRef as ReactComponent };